import globalStore from "@/store";

const settings = {
  namespaced: true,
  state: {
    model: {
      notifyBatteryLevel: 0,
      cowCustomMarkTime: 0,
      notificationEmails: null,
      isVirtualFenceActive: false,
      isNotifyBatteryLevelActive: false,
    },
  },
  actions: {
    GET_SETTINGS: function({ state }) {
      return new Promise((resolve, reject) => {
        globalStore.state.$axios_auth
          .get("/settings")
          .then(function(response) {
            globalStore.commit("settings/SET_MODEL", response.data);
            resolve(response);
          })
          .catch(function(error) {
            reject(error.response);
          });
      });
    },
    CREATE_UPDATE_SETTINGS: function({ state }, model) {
      model.notifyBatteryLevel = Number(model.notifyBatteryLevel);
      model.cowCustomMarkTime = Number(model.cowCustomMarkTime);
      return new Promise((resolve, reject) => {
        globalStore.state.$axios_auth
          .post("/settings", model)
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            reject(error.response);
          });
      });
    },
  },
  mutations: {
    SET_MODEL: function(state, model = null) {
      model == null
        ? (state.model = {
            notifyBatteryLevel: 0,
            cowCustomMarkTime: 0,
            notificationEmails: null,
            isVirtualFenceActive: false,
            isNotifyBatteryLevelActive: false,
          })
        : (state.model = model);
    },
  },
};
export default settings;
